module.exports = __webpack_public_path__ + "img/saas1-sector5.1fc95c12.png";